import { useDispatch } from "react-redux";

import {
  getListData,
  clearListState,
	deleteFlatFeeData,
	clearDeleteState,
	createFlatFeeData,
	clearCreateFlatFeeState,
	updateFlatFeeData,
	clearUpdateFlatFeeState,
	clearDownload,
	setDownloadData,
	getPayoutsData,
	clearPayoutsListData,
	clearCreatePayoutData,
	clearRemovePayoutData,
	clearUpdatePayoutData,
	createPayoutData, removePayoutData, updatePayoutData,
	clearPaymentData, PaymentSetData, setPaymentData,
	getAvailablePaymentsListData,
	getAvailablePaymentsData,
	clearAvailablePaymentsData,
	clearAvailablePaymentsListData,
	clearEditPaymentData,
	editPaymentData,
} from "./index";

export const useFlatFee = () => {
  const dispatch = useDispatch();

  const getList = (data: any) => dispatch(getListData(data));
  const clearList = () => dispatch(clearListState());

	const deleteFlatFee = (data: any) => dispatch(deleteFlatFeeData(data));
	const clearDelete = () => dispatch(clearDeleteState());

	const createFlatFee = (data: any) => dispatch(createFlatFeeData(data));
	const clearCreateFlatFee = () => dispatch(clearCreateFlatFeeState());

	const updateFlatFee = (data: any) => dispatch(updateFlatFeeData(data));
	const clearUpdateFlatFee = () => dispatch(clearUpdateFlatFeeState());

	const setDownload = (data: any) => dispatch(setDownloadData(data));
	const clearDownloadState = () => dispatch(clearDownload());

	const getPayouts = (data: any) => dispatch(getPayoutsData(data));
	const clearPayoutsList = () => dispatch(clearPayoutsListData());
	const createPayout = (data: any) => dispatch(createPayoutData(data));
	const clearCreatePayout = () => dispatch(clearCreatePayoutData());
	const clearUpdatePayout = () => dispatch(clearUpdatePayoutData());
	const clearRemovePayout = () => dispatch(clearRemovePayoutData());
	const updatePayout = (data: any) => dispatch(updatePayoutData(data));
	const removePayout = (data: any) => dispatch(removePayoutData(data));
	const setPayment = (data: PaymentSetData) => dispatch(setPaymentData(data));
	const clearPaymentState = () => dispatch(clearPaymentData());
	const getAvailablePayments = (data: any) => dispatch(getAvailablePaymentsData(data));
	const getAvailablePaymentsList = (data: any) => dispatch(getAvailablePaymentsListData(data));
	const clearAvailablePayments = () => dispatch(clearAvailablePaymentsData());
	const clearAvailablePaymentsList = () => dispatch(clearAvailablePaymentsListData());
	const editPayment = (data: any) => dispatch(editPaymentData(data));
	const clearEditPayment = () => dispatch(clearEditPaymentData());

  return {
    getList,
    clearList,
	  deleteFlatFee,
	  clearDelete,
	  createFlatFee,
	  clearCreateFlatFee,
	  updateFlatFee,
	  clearUpdateFlatFee,
	  setDownload,
	  clearDownloadState,
	  getPayouts,
	  clearPayoutsList,
	  createPayout,
	  clearCreatePayout,
	  clearUpdatePayout,
	  clearRemovePayout,
	  updatePayout,
	  removePayout,
	  setPayment,
	  clearPaymentState,
	  getAvailablePayments,
	  getAvailablePaymentsList,
	  clearAvailablePayments,
	  clearAvailablePaymentsList,
	  editPayment,
	  clearEditPayment,
  }
}
